import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const RouteIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <circle cx="6" cy="19" r="2" />
    <circle cx="18" cy="5" r="2" />
    <path d="M8 19h7.5a3.5 3.5 0 0 0 0-7h-7a3.5 3.5 0 0 1 0-7H16" />
  </svg>
);

export default RouteIcon;
